import './Loader.scss';

const SPINNER_SEGMENTS = 12;

const Loader = () => (
  <div className="loadingio-spinner-spinner-d79520ez52s">
    <div className="ldio-rury1rispbo">
      {Array.from({ length: SPINNER_SEGMENTS }).map((_, index) => (
        <div key={index} />
      ))}
    </div>
  </div>
);

export default Loader;
